import api from './api';

export const getManufacturers = async () => {
  const { data } = await api.get('/manufacturers');
  return data;
};

export const createManufacturer = async (params) => {
  const { data } = await api.post('/manufacturers', params);
  return data;
};

export const updateManufacturer = async (id, params) => {
  const { data } = await api.put(`/manufacturers/${id}`, params);
  return data;
};

export const deleteManufacturer = async (id) => {
  const { data } = await api.delete(`/manufacturers/${id}`);
  return data;
};
